import React, { useState, useRef, useReducer } from 'react';
import { Divider, Popover, Stack, Tab, Tabs } from '@mui/material';
import { styles } from './styles';
import { styles as tabsStyle } from '../Candidate/styles';
import CreateButton from '../Components/Buttons/CreateButton';
import QuestionLibrary from './Question/QuestionLibrary';
import { QuestionLibraryReducer, InitialQuestionLibraryState } from './reducer';
import NewQuestion from './Question/Modals/NewQuestion';
import { ModalType } from './config';
import StyledSnackbar, { ISnackbarInput } from '../Components/CustomUIElements/StyledSnackbar';

export default function Templates() {
  const [tabValue, setTabValue] = useState<number>(0);
  const [actionsAnchorEl, setActionsAnchorEl] = useState<HTMLElement | null>(null);
  const headerRefs = useRef<HTMLDivElement[]>([]);
  const [QuestionState, QuestionDispatch] = useReducer(
    QuestionLibraryReducer,
    InitialQuestionLibraryState
  );

  const newQuestionModalOpen =
    QuestionState.modalsOpen === ModalType.NEW_QUESTION ||
    QuestionState.questionsTableState.actions.isOpen.edit ||
    QuestionState.questionsTableState.actions.isOpen.clone;

  return (
    <Stack sx={styles.templatesPageContainer}>
      <Stack sx={{ flexDirection: 'row', justifyContent: 'space-between' }}>
        <Stack sx={styles.templatesPageHeader}>Templates</Stack>
        <CreateButton
          id="templates-create-button"
          ariaLabel="Create template"
          onClick={(e) => {
            setActionsAnchorEl(e.currentTarget);
          }}
          isOpen={Boolean(actionsAnchorEl)}
        />
        <Popover
          open={Boolean(actionsAnchorEl)}
          anchorEl={actionsAnchorEl}
          onClose={() => setActionsAnchorEl(null)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          sx={styles.actionsMenu}
        >
          <Stack
            onClick={() => {
              QuestionDispatch({ type: 'SET_MODALS_OPEN', payload: ModalType.NEW_QUESTION });
              setActionsAnchorEl(null);
            }}
          >
            Question
          </Stack>
        </Popover>
      </Stack>
      <Stack>
        <Tabs
          value={tabValue}
          onChange={(e, value) => setTabValue(value)}
          variant="scrollable"
          scrollButtons={false}
          sx={{ ...tabsStyle.candidateTabs, '& .MuiTabs-indicator': { background: '#5BC4C0' } }}
        >
          <Tab
            id="application-overview-tab"
            label="Question library"
            ref={(el) => el && (headerRefs.current[0] = el)}
          />
        </Tabs>
        <Divider />
        {tabValue === 0 && (
          <QuestionLibrary QuestionState={QuestionState} QuestionDispatch={QuestionDispatch} />
        )}
      </Stack>
      {newQuestionModalOpen && (
        <NewQuestion
          modalOpen={newQuestionModalOpen}
          onClose={() => {
            QuestionDispatch({ type: 'SET_MODALS_OPEN', payload: null });
            QuestionDispatch({ type: 'CLOSE_ACTION_ITEM', payload: 'edit' });
            QuestionDispatch({ type: 'CLOSE_ACTION_ITEM', payload: 'clone' });
          }}
          selectedQuestion={QuestionState.questionsTableState.actions.selectedItem}
          editingQuestion={QuestionState.questionsTableState.actions.isOpen.edit}
          cloningQuestion={QuestionState.questionsTableState.actions.isOpen.clone}
          setSnackbar={(payload: ISnackbarInput) =>
            QuestionDispatch({ type: 'SET_SNACKBAR', payload: payload })
          }
        />
      )}
      {!!QuestionState.snackbar.message && (
        <StyledSnackbar
          message={QuestionState.snackbar.message}
          state={QuestionState.snackbar.state}
          setSnackbarState={(snackbarInput: ISnackbarInput) =>
            QuestionDispatch({ type: 'SET_SNACKBAR', payload: snackbarInput })
          }
        />
      )}
    </Stack>
  );
}
